"use client";
import { Builder } from "@builder.io/react";

import blogCardRecipe from "./components/BlogCard";
import BlogGridComponent from "./components/BlogGrid";
import arrowButton from "./components/Common/ArrowButton";
import Counter from "./components/Counter/Counter";

Builder.registerComponent(Counter, {
  name: "Counter",
  inputs: [
    {
      name: "initialCount",
      type: "number",
    },
  ],
});

Builder.registerComponent(arrowButton, {
  name: "Arrow Button",
  inputs: [
    {
      name: "content",
      type: "string",
    },
    {
      name: "color",
      type: "string",
    },
    {
      name: "arrow",
      type: "boolean",
    },
    {
      name: "width",
      type: "string",
    },
  ],
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/3d-cube-sphere-off.png",
});

Builder.registerComponent(blogCardRecipe, {
  name: "Weird Blog",
  inputs: [],
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/3d-cube-sphere-off.png",
});

Builder.registerComponent(BlogGridComponent, {
  name: "Weird Grid",
  inputs: [],
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/3d-cube-sphere-off.png",
});
